export default __webpack_public_path__ + "static/media/luniu-supply-chain.b8c7fbeb.png";